import React from 'react';
import EndpointWorkbench from '../components/EndpointWorkbench';
import { endpointService } from '../services/endpointService';

const HybridPage: React.FC = () => {
  return (
    <EndpointWorkbench
      title="Sorgu At"
      subtitle="Hybrid retrieval endpointini uygulama içinde ayrı izleyin; canlı request/response ve paginated geçmişi tek ekranda görün."
      endpointBadge="/api/hybrid/query"
      accent="hybrid"
      queryButtonLabel="Sorgu At"
      historyTitle="Sorgu At Geçmişi"
      historySubtitle="Public endpoint ve uygulama içinden yapılan hybrid istekleri burada request ve response olarak ayrı bloklarda görüntülenir."
      presets={[
        'Ön kapı bölgesi aç kapada gıcırtı sesi var',
        'Şanzıman yağı fazla',
        'Multimedya oturmamış'
      ]}
      queryPlaceholder="Hata açıklamasını yazın..."
      historyEmptyText="Henüz Sorgu At kaydı bulunmuyor."
      latestEmptyText="Sorgu At çalıştırıldığında son yanıt burada görünecek."
      query={endpointService.queryHybrid}
      loadHistory={endpointService.getHybridHistory}
    />
  );
};

export default HybridPage;
